import {Injectable} from '@angular/core';
import Ajv from 'ajv';
import addFormats from 'ajv-formats';
import {Validator} from 'ip-num/Validator';

@Injectable({
    providedIn: 'root'
})
export class SchemaHelperService {
    static ipv4Format;
    static ipv6Format;

    constructor() {
        const ajv: any = this.ajvInstance;
        addFormats(ajv);
        SchemaHelperService.ipv4Format = ajv.formats.ipv4;
        SchemaHelperService.ipv6Format = Validator.IPV6_RANGE_PATTERN;
    }

    get ajvInstance(){
        return new Ajv({allErrors: true, verbose: true, removeAdditional: true, unicodeRegExp: false, strictTypes: false, strict: false}); // options can be passed
    }

    static split(fromIpAddress: any, toIpAddress: any, splitBy: string) {
        return {
            fromStart: fromIpAddress.substring(0, fromIpAddress.lastIndexOf(splitBy)),
            toStart: toIpAddress.substring(0, toIpAddress.lastIndexOf(splitBy)),
            fromEnd: fromIpAddress.substring(fromIpAddress.lastIndexOf(splitBy) + 1),
            toEnd: toIpAddress.substring(toIpAddress.lastIndexOf(splitBy) + 1)
        };
    }

    static validateIPAddress = (ipAddress, validate: 'ipv4' | 'ipv6' | 'both' = 'ipv4') => {
        const isIPv4 = ['ipv4', 'both'].includes(validate) && SchemaHelperService.ipv4Format.test(ipAddress);
        const isIPv6 = ['ipv6', 'both'].includes(validate) && SchemaHelperService.ipv6Format.test(ipAddress);
        return isIPv4 || isIPv6;
    };

    static validateSerialNumber = (serialNumber) => /^[0-9]*$/.test(serialNumber);

    static buildErrorItem = ({
        inputName,
        message = undefined,
        isArray = false,
        index = undefined,
        keyword = undefined,
        limit = undefined
    }) =>  {
        let instancePath = inputName.replace(/\./g,'/').split('/');
        instancePath.shift();
        instancePath = '/' + instancePath.join('/');
        return {
            instancePath,
            inputName,
            messageAux: message,
            isArray,
            index,
            keyword: keyword || 'aux',
            params: {limit}
        };
    }
}
